import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  open(event) {
    const element = event.currentTarget;
    const isSelect = element.tagName === 'SELECT';

    const url = element.dataset.newAccountUrl;
    const frameId = element.dataset.turboFrame;
    const autoSubmit = element.dataset.autoSubmit;

    const loadIntoFrame = (targetUrl, targetFrameId) => {
      if (!targetUrl || !targetFrameId) return;

      const turboFrame = document.getElementById(targetFrameId);

      if (turboFrame) {
        turboFrame.setAttribute('src', targetUrl);
      }
    };

    if (isSelect) {
      const value = element.value;
      if (value === 'new_account') {
        event.preventDefault();
        loadIntoFrame(url, frameId);
      } else if (autoSubmit) {
        element.form?.requestSubmit();
      }
      return;
    }

    // Handle button clicks (or other non-select elements)
    event.preventDefault();
    loadIntoFrame(url, frameId);
  }
}
